import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IShippingPolicy, ShippingPolicyCreateRequest } from './../models/ShippingPolicy';
import { DefaultResponseWithData } from './../models/system';

export default function useShippingPolicies() {
  const { get, post, put, del } = useApiHelper();
  const queryClient = useQueryClient();
  const staleTime = 1000 * 60 * 10; // 10 minutes

  const shippingPolicies = useQuery({
    queryKey: ["shippingPolicies"],
    queryFn: () => get<DefaultResponseWithData<IShippingPolicy[]>>("/shippingpolicy"),
    staleTime: staleTime,
  });

  const create = useMutation(
    (policy: ShippingPolicyCreateRequest) => post(`/shippingpolicy`, policy),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["shippingPolicies"]);
      },
    }
  );

  const update = useMutation(
    (policy: IShippingPolicy) => put(`/shippingpolicy`, policy),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["shippingPolicies"]);
      },
    }
  );

  const remove = useMutation(
    (policyId: string) => del(`/shippingpolicy/${policyId}`),
      {
      onSuccess: () => {
        queryClient.invalidateQueries(["shippingPolicies"]);
      },
    }
  )

  return {
    shippingPolicies,
    create,
    update,
    remove
  };
}
